
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 18.286h-3.474v-3.429H16.21v3.429h-3.473v2.285h3.473V24h2.316v-3.429H22M2.316 0C1.03 0 0 1.029 0 2.286V20.57c0 1.269 1.03 2.286 2.316 2.286h9.043a6.825 6.825 0 01-.845-2.286H2.316V2.286h8.105V8h5.79v4.663a7.897 7.897 0 011.157-.092c.394 0 .776.035 1.158.092V6.857L11.58 0M4.632 11.429v2.285h9.263V11.43M4.632 16v2.286h5.79V16h-5.79z","fill":"#01579B"}})])
          )
        }
      }
    